{
  "auth": {
    "agree": "我同意",
    "createAccount": "创建账号",
    "createNewAccount": "创建新账号",
    "email": "邮箱",
    "login": "登录",
    "password": "密码",
    "username": "用户名",
    "recover_password": "找回密码",
    "sign_up": "注册",
    "keep_logged_in": "保持登录状态",
    "termsOfUse": "使用条款",
    "reset_password": "重置密码",
    "recover_password_text": "输入您的邮箱，我们将发送重置密码的链接",
    "go_back": "返回",
    "check_email": "查看邮箱",
    "check_email_text": "请查看您的邮箱，按照邮件中的说明操作。",
    "back_to_login": "返回登录页面",
    "reset_password_text": "输入新密码",
    "new_password": "新密码",
    "confirm_password": "确认密码",
    "password_updated": "密码已更新",
    "password_updated_text": "您的密码已成功更新。点击下方按钮返回登录页面。",
    "loginDescription": "登录您的账号以继续",
    "rememberMe": "记住我",
    "forgotPassword": "忘记密码？",
    "noAccount": "还没有账号？",
    "usernameRequired": "用户名不能为空",
    "passwordRequired": "密码不能为空",
    "loginSuccess": "登录成功",
    "loginFailed": "登录失败，请检查您的凭证。",
    "newPassword": "新密码",
    "confirmPassword": "确认密码"
  },
  "menu": {
    "dashboard": "仪表盘",
    "users": "用户",
    "projects": "项目",
    "userManagement": "用户管理",
    "userList": "用户列表",
    "userRoles": "角色管理",
    "productManagement": "产品管理",
    "productList": "产品列表",
    "productCategories": "产品分类",
    "productBrands": "品牌管理",
    "orderManagement": "订单管理",
    "orderList": "订单列表",
    "orderReturns": "退货管理",
    "jobManagement": "招聘求职管理",
    "jobList": "招聘列表",
    "jobSeekerList": "求职列表",
    "companyList": "公司列表",
    "articleList": "文章管理",
    "houseManagement": "房屋管理",
    "houseList": "房屋列表",
    "secondHandManagement": "二手管理",
    "secondHandGoods": "二手商品管理",
    "secondHandCars": "二手车管理",
    "categoryManagement": "分类管理",
    "categoryManagementCars": "分类管理",
    "goodsManagement": "商品管理",
    "carsManagement": "车辆管理",
    "systemSettings": "系统设置",
    "siteSettings": "网站设置",
    "paymentSettings": "支付设置",
    "shippingSettings": "物流设置",
    "productsDirectLink": "产品列表（直接链接）",
    "payments": "支付",
    "payment-methods": "支付方式",
    "pricing-plans": "定价计划",
    "billing": "账单",
    "auth": "认证",
    "login": "登录",
    "signup": "注册",
    "recover-password": "找回密码",
    "faq": "常见问题",
    "404": "404",
    "preferences": "偏好设置",
    "apiTest": "API 测试"
  },
  "messages": {
    "all": "查看所有消息",
    "new": "来自{name}的新消息"
  },
  "notifications": {
    "all": "查看所有通知",
    "new": "来自{name}的新通知"
  },
  "search": {
    "placeholder": "搜索..."
  },
  "settings": {
    "language": "语言"
  },
  "aboutVuesticAdmin": "关于 Vuestic Admin",
  "helpAndSupport": "帮助与支持",
  "common": {
    "edit": "编辑",
    "delete": "删除",
    "save": "保存",
    "cancel": "取消",
    "close": "关闭",
    "add": "添加",
    "update": "更新",
    "confirm": "确认",
    "back": "返回",
    "next": "下一步",
    "previous": "上一步",
    "submit": "提交",
    "reset": "重置",
    "search": "搜索",
    "filter": "筛选",
    "sort": "排序",
    "refresh": "刷新",
    "loading": "加载中...",
    "search": "搜索",
    "title": "标题",
    "company": "公司",
    "salary": "薪资",
    "location": "地点",
    "status": "状态",
    "createdAt": "创建时间",
    "actions": "操作",
    "jobDetail": "招聘详情",
    "description": "描述",
    "requirements": "要求",
    "fetchError": "获取数据失败",
    "deleteSuccess": "删除成功",
    "deleteError": "删除失败",
    "confirmDelete": "确认删除？",
    "addJob": "添加招聘",
    "addHouse": "添加房屋",
    "houseDetail": "房屋详情",
    "facilities": "配套设施",
    "noData": "暂无数据",
    "error": "错误",
    "success": "成功",
    "warning": "警告",
    "info": "信息"
  },
  "user": {
    "addUser": "添加用户",
    "editUser": "编辑用户",
    "deleteUser": "删除用户",
    "userSaved": "用户已保存",
    "userDeleted": "用户已删除",
    "userUpdated": "用户已更新",
    "userAdded": "用户已添加",
    "confirmDeleteUser": "确定要删除此用户吗？",
    "formUnsavedChanges": "表单有未保存的更改。确定要关闭吗？",
    "saveUser": "保存用户",
    "addUserButton": "添加用户",
    "account": "用户账户",
    "profile": "个人资料",
    "settings": "设置",
    "billing": "账单",
    "projects": "项目",
    "explore": "探索",
    "faq": "常见问题",
    "helpAndSupport": "帮助与支持",
    "logout": "退出登录",
    "member": "会员"
  },
  "profile": {
    "personalInfo": "个人信息",
    "security": "安全设置",
    "nickname": "昵称",
    "mobile": "手机号",
    "gender": "性别",
    "birthday": "生日",
    "saveChanges": "保存更改",
    "currentPassword": "当前密码",
    "newPassword": "新密码",
    "confirmNewPassword": "确认新密码",
    "updatePassword": "更新密码",
    "genderUnknown": "未知",
    "genderMale": "男",
    "genderFemale": "女",
    "profileUpdateSuccess": "个人资料更新成功",
    "profileUpdateFailed": "个人资料更新失败",
    "passwordUpdateSuccess": "密码更新成功",
    "passwordUpdateFailed": "密码更新失败",
    "currentPasswordRequired": "请输入当前密码",
    "newPasswordRequired": "请输入新密码",
    "confirmPasswordRequired": "请确认新密码",
    "passwordsDoNotMatch": "两次输入的密码不一致",
    "uploadAvatar": "上传头像",
    "changeAvatar": "更换头像"
  },
  "product": {
    "addProduct": "添加产品",
    "editProduct": "编辑产品",
    "deleteProduct": "删除产品",
    "productSaved": "产品已保存",
    "productDeleted": "产品已删除",
    "productUpdated": "产品已更新",
    "productAdded": "产品已添加",
    "confirmDeleteProduct": "确定要删除此产品吗？"
  },
  "billing": {
    "saveAddress": "保存地址",
    "save16Percent": "节省 16%",
    "switchToYearlySave": "16%"
  },
  "address": {
    "confirmDeleteAddress": "确定要删除此地址吗？",
    "addressDeleted": "地址已删除"
  }
}
